import { BehaviorService } from '@_services/Behavior.service';
import { HyperlinkNavigationService } from '@_services/hyperlink-navigation.service';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import { TimersService } from '@_services/timers.service';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { LogoutErrorComponent } from 'src/app/main/logout-error/logout-error.component';
import { AuthenticationService } from '@_services/authentication.service';
import { DIALOG_WIDTH } from '@/app/_constant/dialog-width.constants';

@Component({
  selector: 'app-preferences',
  templateUrl: './preferences.component.html',
  styleUrls: ['./preferences.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreferencesComponent implements OnInit, OnDestroy {
  isspiner: boolean = false;
  hide: boolean = true;
  sub1: Subscription;
  currentuser: any = JSON.parse(localStorage.getItem('currentUser'));
  preferenceObjectData: any = JSON.parse(localStorage.getItem('currentUser'));
  PreferenceForm: FormGroup;
  fuseConfigrationForm: FormGroup;
  isSolacitor: any = this.currentuser?.PRODUCTTYPE;
  fuseConfig: any;
  MatterDropData: any[] = [];
  colorThemeval: any;
  dialogRef: any;
  InitialWindow: string[] = [
    'Matter',
    'Trust',
    'Time Entries',
    'Contacts',
    'Spend Money',
    'Receive Money',
    'Invoices',
    'Diary',
    'Authorities',
    'Chart of Accounts',
    'Trust Chart of Accounts',
    'Safe Custody',
    'DashBoard',
    'Trust End of Month',
  ];
  quantType: any[] = [
    { Name: 'Minutes', value: 'M' },
    { Name: 'hh:mm', value: 'X' },
    { Name: 'Hours', value: 'H' },
    { Name: 'Days', value: 'D' },
    { Name: 'Units', value: 'U' },
    { Name: 'Fixed', value: 'F' },
  ];
  private _unsubscribeAll: Subject<void> = new Subject();
  @ViewChild('scrollToDiv') scrollToDiv: ElementRef;

  constructor(
    private renderer: Renderer2,
    public behaviorService: BehaviorService,
    public _mainAPiServiceService: MainAPiServiceService,
    public _formBuilder: FormBuilder,
    private Timersservice: TimersService,
    private toastr: ToastrService,
    public hyperlink: HyperlinkNavigationService,
    public _matDialog: MatDialog,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private authenticationService: AuthenticationService,
  ) {
    this.behaviorService.APIretryCall$.pipe(takeUntil(this._unsubscribeAll)).subscribe({
      next: (result: any) => {
        if (result && result['click'] && result['data'] && result['data']['preference']) {
          this.preferenceSave();
        }
      },
    });

    this.behaviorService.GetPreferences$.pipe(takeUntil(this._unsubscribeAll)).subscribe({
      next: (result: any) => {
        if (result) {
          this.preferenceObjectData = result;
        } else {
          this.preferenceObjectData = JSON.parse(localStorage.getItem('currentUser'));
        }
        this.cdr.markForCheck();
      },
    });
    this.fuseConfigration();
  }

  ngOnInit(): void {
    this.PreferenceForm = this._formBuilder.group({
      SORTBYSURNAME: new FormControl(''),
      SORTMATTERALPHANUMERICALLY: new FormControl(''),
      SORTPACKETSALPHANUMERICALLY: new FormControl(''),
      LOADALLUSERSMATTERS: new FormControl(''),
      POPUPSELECTMATTERFIRST: new FormControl(''),
      SAVEEMAILSTOREGISTER: new FormControl(''),
      LOADPREVIOUSXDAYS: new FormControl(''),
      SHOWREMINDERS: new FormControl(''),
      THUMBNAILSIZE: new FormControl(''),
      WORKINGONBEHALFOFGUID: new FormControl(''),
      DEFAULTOWNERGUID: new FormControl(''),
      DEFAULTPRIMARYFEEEARNERGUID: new FormControl(''),
      DEFAULTASSISTANTGUID: new FormControl(''),
      INITIALWINDOW: new FormControl(''),
      DEFAULTQUANTITYTYPE: new FormControl(''),
      OPENINNEWTAB: new FormControl(''),
      SHOWEMAILCC: new FormControl(''),
      SHOWEMAILBCC: new FormControl(''),
      SHOWDISBURSEMENTS: new FormControl(''),
      SHOWINACTIVEFEEEARNERS: new FormControl(''),
      CONTACTDEFAULTTYPE: new FormControl(''),
      CONTACTSTARTSWITH: new FormControl(''),
      CONTACTACTIVE: new FormControl(''),
      PREFILLTIMEOFDAY: new FormControl(''),
      SAVEREPORTSTONETDRIVE: new FormControl(''),
      EMAILCSVFILE: new FormControl(''),
      CONVERTTOPDF: new FormControl(''),
      THEMECOLOUR: new FormControl(''),
      THEMECOLOURToggle: new FormControl(''),
      NAVBARHIDE: new FormControl(''),
      NAVBARFOLDED: new FormControl(''),
      SIDEPANELHIDE: new FormControl(''),
      MATTERDETAILSTABTEXT: new FormControl(''),
      USEV11UI: new FormControl(''),
      PRODUCTTYPE: new FormControl(''),
      DELIVERABLES: new FormControl(''),
      UNITSPERHOUR: new FormControl(''),
      DISBURSEMENTACCOUNTGUID: new FormControl(''),
      TAXPAYABLEACCOUNTGUID: new FormControl(''),
      DONTAUTOALLOCATERECEIPT: new FormControl(''),
      EMAILSYSTEM: new FormControl(''),
      DOCUMENTSYSTEM: new FormControl(''),
      SMTPEMAILADDRESS: [''],
      SMTPSERVER: [''],
      SMTPPORT: [],
      SMTPUSESSL: [false],
      SMTPUSERNAME: [''],
      SMTPPASSWORD: [''],
      DEFAULTTASKVIEW: [''],
    });
    this.DefaultFeeEarner();
    this.defaultsetPrefernce();
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {
    this.sub1?.unsubscribe();
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  get f(): any {
    return this.PreferenceForm.controls;
  }

  fuseConfigration(): void {
    this.behaviorService.setToolBaarSetting({
      NAVBARFOLDED: this.preferenceObjectData.NAVBARFOLDED,
      NAVBARHIDE: this.preferenceObjectData.NAVBARHIDE,
      OPENINNEWTAB: this.preferenceObjectData.OPENINNEWTAB,
      OPENINNEWTABWINDOWS: this.preferenceObjectData.OPENINNEWTABWINDOWS,
      USEV11UI: this.preferenceObjectData.USEV11UI,
    });

    this.fuseConfigrationForm = this._formBuilder.group({
      colorTheme: new FormControl(),
      customScrollbars: new FormControl(),
      layout: this._formBuilder.group({
        style: new FormControl(),
        width: new FormControl(),
        navbar: this._formBuilder.group({
          primaryBackground: new FormControl(),
          secondaryBackground: new FormControl(),
          folded: new FormControl(),
          hidden: new FormControl(),
          position: new FormControl(),
          variant: new FormControl(),
        }),
        toolbar: this._formBuilder.group({
          background: new FormControl(),
          customBackgroundColor: new FormControl(),
          hidden: new FormControl(),
          position: new FormControl(),
        }),
        footer: this._formBuilder.group({
          background: new FormControl(),
          customBackgroundColor: new FormControl(),
          hidden: new FormControl(),
          position: new FormControl(),
        }),
        sidepanel: this._formBuilder.group({
          hidden: new FormControl(),
          position: new FormControl(),
        }),
      }),
    });

    this.fuseConfigrationForm
      .get('layout.style')
      ?.valueChanges.pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (value: any) => {},
      });

    this.fuseConfigrationForm.valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe({
      next: (config: any) => {},
    });
  }

  toggleSidebarOpen(key: any): void {}

  private _resetFormValues(value: any): void {
    switch (value) {
      case 'vertical-layout-1': {
        this.fuseConfigrationForm.patchValue({
          layout: {
            width: 'fullwidth',
            navbar: {
              primaryBackground: 'fuse-navy-700',
              secondaryBackground: 'fuse-navy-900',
              folded: false,
              hidden: false,
              position: 'left',
              variant: 'vertical-style-1',
            },
            toolbar: {
              background: 'fuse-white-500',
              customBackgroundColor: false,
              hidden: false,
              position: 'below-static',
            },
            footer: {
              background: 'fuse-navy-900',
              customBackgroundColor: true,
              hidden: false,
              position: 'below-static',
            },
            sidepanel: {
              hidden: false,
              position: 'right',
            },
          },
        });
        break;
      }
    }
  }

  DefaultThemColor(): void {
    if (this.isSolacitor == 'Solicitor') {
      if (this.preferenceObjectData?.THEMECOLOUR == 'theme-yellow-light') {
        this.colorThemeval = 'theme-yellow-light';
        this.PreferenceForm.controls['THEMECOLOUR'].setValue(this.colorThemeval);
        this.PreferenceForm.controls['THEMECOLOURToggle'].setValue(false);
      } else {
        this.colorThemeval = 'theme-blue-gray-dark';
        this.PreferenceForm.controls['THEMECOLOUR'].setValue(this.colorThemeval);
        this.PreferenceForm.controls['THEMECOLOURToggle'].setValue(true);
      }
    } else {
      if (this.preferenceObjectData?.THEMECOLOUR == 'theme-default') {
        this.colorThemeval = 'theme-default';
        this.PreferenceForm.controls['THEMECOLOUR'].setValue(this.colorThemeval);
        this.PreferenceForm.controls['THEMECOLOURToggle'].setValue(false);
      } else {
        this.colorThemeval = 'theme-pink-dark';
        this.PreferenceForm.controls['THEMECOLOUR'].setValue(this.colorThemeval);
        this.PreferenceForm.controls['THEMECOLOURToggle'].setValue(true);
      }
    }
    this.preferenceObjectData['THEMECOLOUR'] = this.f['THEMECOLOUR'].value;
    this.cdr.markForCheck();
  }

  defaultsetPrefernce(): void {
    this.PreferenceForm.controls['SORTBYSURNAME'].setValue(
      this.preferenceObjectData?.SORTBYSURNAME,
    );
    this.PreferenceForm.controls['SORTMATTERALPHANUMERICALLY'].setValue(
      this.preferenceObjectData?.SORTMATTERALPHANUMERICALLY,
    );
    this.PreferenceForm.controls['SORTPACKETSALPHANUMERICALLY'].setValue(
      this.preferenceObjectData?.SORTPACKETSALPHANUMERICALLY,
    );
    this.PreferenceForm.controls['LOADALLUSERSMATTERS'].setValue(
      this.preferenceObjectData?.LOADALLUSERSMATTERS,
    );
    this.PreferenceForm.controls['POPUPSELECTMATTERFIRST'].setValue(
      this.preferenceObjectData?.POPUPSELECTMATTERFIRST,
    );
    this.PreferenceForm.controls['SAVEEMAILSTOREGISTER'].setValue(
      this.preferenceObjectData?.SAVEEMAILSTOREGISTER,
    );
    this.PreferenceForm.controls['LOADPREVIOUSXDAYS'].setValue(
      this.preferenceObjectData?.LOADPREVIOUSXDAYS.toString(),
    );
    this.PreferenceForm.controls['SHOWREMINDERS'].setValue(
      this.preferenceObjectData?.SHOWREMINDERS,
    );
    this.PreferenceForm.controls['THUMBNAILSIZE'].setValue(
      this.preferenceObjectData?.THUMBNAILSIZE,
    );
    this.PreferenceForm.controls['WORKINGONBEHALFOFGUID'].setValue(
      this.preferenceObjectData?.WORKINGONBEHALFOFGUID,
    );
    this.PreferenceForm.controls['DEFAULTOWNERGUID'].setValue(
      this.preferenceObjectData?.DEFAULTOWNERGUID,
    );
    this.PreferenceForm.controls['DEFAULTPRIMARYFEEEARNERGUID'].setValue(
      this.preferenceObjectData?.DEFAULTPRIMARYFEEEARNERGUID,
    );
    this.PreferenceForm.controls['DEFAULTASSISTANTGUID'].setValue(
      this.preferenceObjectData?.DEFAULTASSISTANTGUID,
    );

    this.PreferenceForm.controls['INITIALWINDOW'].setValue(
      this.preferenceObjectData?.initialwindow,
    );
    this.PreferenceForm.controls['DEFAULTQUANTITYTYPE'].setValue(
      this.preferenceObjectData?.DEFAULTQUANTITYTYPE,
    );
    this.PreferenceForm.controls['OPENINNEWTAB'].setValue(this.preferenceObjectData?.OPENINNEWTAB);
    this.PreferenceForm.controls['SHOWEMAILCC'].setValue(this.preferenceObjectData?.SHOWEMAILCC);
    this.PreferenceForm.controls['SHOWEMAILBCC'].setValue(this.preferenceObjectData?.SHOWEMAILBCC);
    this.PreferenceForm.controls['SHOWDISBURSEMENTS'].setValue(
      this.preferenceObjectData?.SHOWDISBURSEMENTS,
    );
    this.PreferenceForm.controls['SHOWINACTIVEFEEEARNERS'].setValue(
      this.preferenceObjectData?.SHOWINACTIVEFEEEARNERS,
    );
    this.PreferenceForm.controls['DEFAULTTASKVIEW'].setValue(
      this.preferenceObjectData?.DEFAULTTASKVIEW,
    );

    this.PreferenceForm.controls['CONTACTDEFAULTTYPE'].setValue(
      this.preferenceObjectData?.CONTACTDEFAULTTYPE,
    );
    this.PreferenceForm.controls['CONTACTSTARTSWITH'].setValue(
      this.preferenceObjectData?.CONTACTSTARTSWITH,
    );
    this.PreferenceForm.controls['CONTACTACTIVE'].setValue(
      this.preferenceObjectData?.CONTACTACTIVE,
    );
    this.PreferenceForm.controls['PREFILLTIMEOFDAY'].setValue(
      this.preferenceObjectData?.PREFILLTIMEOFDAY,
    );
    this.PreferenceForm.controls['SAVEREPORTSTONETDRIVE'].setValue(
      this.preferenceObjectData?.SAVEREPORTSTONETDRIVE,
    );

    this.PreferenceForm.controls['EMAILCSVFILE'].setValue(this.preferenceObjectData?.EMAILCSVFILE);
    this.PreferenceForm.controls['CONVERTTOPDF'].setValue(this.preferenceObjectData?.CONVERTTOPDF);
    this.DefaultThemColor();

    this.PreferenceForm.controls['NAVBARHIDE'].setValue(this.preferenceObjectData?.NAVBARHIDE);
    this.PreferenceForm.controls['NAVBARFOLDED'].setValue(this.preferenceObjectData?.NAVBARFOLDED);
    this.PreferenceForm.controls['SIDEPANELHIDE'].setValue(
      this.preferenceObjectData?.SIDEPANELHIDE,
    );
    this.PreferenceForm.controls['MATTERDETAILSTABTEXT'].setValue(
      this.preferenceObjectData?.MATTERDETAILSTABTEXT,
    );

    this.PreferenceForm.controls['USEV11UI'].setValue(this.preferenceObjectData?.USEV11UI);
    this.PreferenceForm.controls['PRODUCTTYPE'].setValue(this.preferenceObjectData?.PRODUCTTYPE);
    this.PreferenceForm.controls['DELIVERABLES'].setValue(this.preferenceObjectData?.DELIVERABLES);
    this.PreferenceForm.controls['UNITSPERHOUR'].setValue(this.preferenceObjectData?.UNITSPERHOUR);
    this.PreferenceForm.controls['DISBURSEMENTACCOUNTGUID'].setValue(
      this.preferenceObjectData?.DISBURSEMENTACCOUNTGUID,
    );
    this.PreferenceForm.controls['TAXPAYABLEACCOUNTGUID'].setValue(
      this.preferenceObjectData?.TAXPAYABLEACCOUNTGUID,
    );
    this.PreferenceForm.controls['DONTAUTOALLOCATERECEIPT'].setValue(
      this.preferenceObjectData?.DONTAUTOALLOCATERECEIPT,
    );
    this.PreferenceForm.controls['EMAILSYSTEM'].setValue(this.preferenceObjectData?.EMAILSYSTEM);
    this.PreferenceForm.controls['DOCUMENTSYSTEM'].setValue(
      this.preferenceObjectData?.DOCUMENTSYSTEM,
    );
    this.getPreferences();
  }

  getPreferences(): void {
    this._mainAPiServiceService
      .getSetData({ Action: 'GetData', Filters: {} }, 'preference')
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && response.STATUS == 'success') {
            let DefultVal: any = response.DATA;
            this.PreferenceForm.controls['SMTPEMAILADDRESS'].setValue(DefultVal.SMTPEMAILADDRESS);
            this.PreferenceForm.controls['SMTPSERVER'].setValue(DefultVal.SMTPSERVER);
            this.PreferenceForm.controls['SMTPPORT'].setValue(DefultVal.SMTPPORT);
            this.PreferenceForm.controls['SMTPUSESSL'].setValue(DefultVal.SMTPUSESSL);
            this.PreferenceForm.controls['SMTPPASSWORD'].setValue(DefultVal.SMTPPASSWORD);
            this.PreferenceForm.controls['SMTPUSERNAME'].setValue(DefultVal.SMTPUSERNAME);
            this.PreferenceForm.controls['PREFILLTIMEOFDAY'].setValue(DefultVal.PREFILLTIMEOFDAY);
            this.PreferenceForm.controls['WORKINGONBEHALFOFGUID'].setValue(
              DefultVal?.WORKINGONBEHALFOFGUID,
            );
            this.PreferenceForm.controls['DEFAULTOWNERGUID'].setValue(DefultVal?.DEFAULTOWNERGUID);
            this.PreferenceForm.controls['DEFAULTPRIMARYFEEEARNERGUID'].setValue(
              DefultVal?.DEFAULTPRIMARYFEEEARNERGUID,
            );
            this.PreferenceForm.controls['DEFAULTASSISTANTGUID'].setValue(
              DefultVal?.DEFAULTASSISTANTGUID,
            );
            this.PreferenceForm.controls['INITIALWINDOW'].setValue(DefultVal?.INITIALWINDOW);
            this.PreferenceForm.controls['DEFAULTQUANTITYTYPE'].setValue(
              DefultVal?.DEFAULTQUANTITYTYPE,
            );
            this.PreferenceForm.controls['SHOWEMAILCC'].setValue(DefultVal?.SHOWEMAILCC);
            this.PreferenceForm.controls['SHOWEMAILBCC'].setValue(DefultVal?.SHOWEMAILBCC);
            this.PreferenceForm.controls['MATTERDETAILSTABTEXT'].setValue(
              DefultVal?.MATTERDETAILSTABTEXT,
            );
          }
          this.behaviorService.loadingSystemSetting('email-configuration');
          this.cdr.markForCheck();
        },
        error: (error: any) => {
          this.behaviorService.loadingSystemSetting('email-configuration');
          this.toastr.error(error);
          this.cdr.markForCheck();
        },
      });
  }

  DefaultFeeEarner(): void {
    let userList: any = JSON.parse(localStorage.getItem('users_list'));
    if (userList && userList != null) {
      this.MatterDropData = this.Timersservice.removeUSerWithoutId(userList);
      this.cdr.markForCheck();
    } else {
      this.Timersservice.GetUsers({})
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe({
          next: (response: any) => {
            if (response.CODE == 200 && response.STATUS == 'success') {
              this.MatterDropData = this.Timersservice.removeUSerWithoutId(response.DATA.USERS);
              localStorage.setItem('users_list', JSON.stringify(response.DATA.USERS));
            }
            this.cdr.markForCheck();
          },
          error: (err: any) => {
            this.cdr.markForCheck();
          },
        });
    }
  }

  checkboxClick(type: any): void {
    this.PreferenceForm.controls[type].setValue(this.f[type].value);
    if (this.preferenceObjectData) {
      this.preferenceObjectData[type] = this.f[type].value;
    }
    this.cdr.markForCheck();
  }

  changeSelectWindow(type: any): void {
    this.PreferenceForm.controls[type].setValue(this.f[type].value);
    if (this.preferenceObjectData) {
      this.preferenceObjectData[type] = this.f[type].value;
    }
    this.cdr.markForCheck();
  }

  themeradiobtn(val: any): void {
    if (this.isSolacitor == 'Solicitor') {
      if (val.checked == true) {
        this.colorThemeval = 'theme-blue-gray-dark';
      } else {
        this.colorThemeval = 'theme-yellow-light';
      }
    } else {
      if (val.checked == true) {
        this.colorThemeval = 'theme-pink-dark';
      } else {
        this.colorThemeval = 'theme-default';
      }
    }

    this.f['THEMECOLOUR'].value = this.colorThemeval;
    this.PreferenceForm.controls['THEMECOLOUR'].setValue(this.f['THEMECOLOUR'].value);
    if (this.preferenceObjectData) {
      this.preferenceObjectData['THEMECOLOUR'] = this.f['THEMECOLOUR'].value;
    }
    this.cdr.markForCheck();
  }

  themePanel(val: any, event?: any): void {
    this.PreferenceForm.controls[val].setValue(this.f[val].value);
    if (this.preferenceObjectData) {
      this.preferenceObjectData[val] = this.f[val].value;
    }
    if (val == 'USEV11UI') {
      this.dialogRef = this._matDialog.open(LogoutErrorComponent, {
        disableClose: true,
        width: DIALOG_WIDTH.FULL,
        data: {
          MESSAGE:
            'You need to logout of SILQ and close all SILQ tabs. Then log back in to access the selected UI. <br/><br/> Are you sure you want to change the UI?',
          USEV11UI: true,
        },
      });

      this.dialogRef
        .afterClosed()
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe({
          next: (result: any) => {
            if (!result) {
              this.preferenceObjectData.USEV11UI = !this.preferenceObjectData.USEV11UI;
              this.PreferenceForm.controls[val].setValue(this.preferenceObjectData.USEV11UI);
            } else {
              this.preferenceObjectData.USEV11UI = this.preferenceObjectData.USEV11UI;
              this.PreferenceForm.controls[val].setValue(this.preferenceObjectData.USEV11UI);
            }
            this.cdr.markForCheck();
          },
        });
    } else {
      this.cdr.markForCheck();
    }
  }

  preferenceSave(): void {
    this.isspiner = true;
    const previousTheme = this.currentuser?.THEMECOLOUR;
    let details: any = {
      FormAction: 'update',
      VALIDATEONLY: false,
      Data: this.PreferenceForm.value,
    };
    this._mainAPiServiceService
      .getSetData(details, 'preference')
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            for (const key in this.PreferenceForm.value) {
              this.currentuser[key] = this.PreferenceForm.value[key];
              this.behaviorService.UpdatedColorSystemSetting$.next(this.colorThemeval);
              localStorage.setItem('theme_type', this.PreferenceForm.controls['THEMECOLOUR'].value);
              localStorage.setItem(
                'MatterWindow_Open_Status',
                JSON.stringify(this.PreferenceForm.value.POPUPSELECTMATTERFIRST),
              );
              this.behaviorService.MatterPopupStatus$.next(
                this.PreferenceForm.value.POPUPSELECTMATTERFIRST,
              );

              if (key == 'DEFAULTQUANTITYTYPE') {
                this.behaviorService.setDefultPreferencesData(this.preferenceObjectData);
              }
              if (key == 'WORKINGONBEHALFOFGUID') {
                this.behaviorService.setDefultFeeErnerData(
                  this.preferenceObjectData.WORKINGONBEHALFOFGUID,
                );
              }
              if (key == 'DEFAULTOWNERGUID') {
                this.behaviorService.setDefultFeeErnerData(
                  this.preferenceObjectData.DEFAULTOWNERGUID,
                );
              }
              if (key == 'DEFAULTPRIMARYFEEEARNERGUID') {
                this.behaviorService.setDefultFeeErnerData(
                  this.preferenceObjectData.DEFAULTPRIMARYFEEEARNERGUID,
                );
              }
              if (key == 'DEFAULTASSISTANTGUID') {
                this.behaviorService.setDefultFeeErnerData(
                  this.preferenceObjectData.DEFAULTASSISTANTGUID,
                );
              }
              if (key == 'USEV11UI') {
                this.behaviorService.GetPreferences$.next(this.preferenceObjectData);
                this.behaviorService.matterDetailsWindow$.next(this.currentuser);
              }

              if (key == 'MATTERDETAILSTABTEXT') {
                let MATTERDETAILSTABTEXT = JSON.parse(localStorage.getItem('set_preferences'));
                if (MATTERDETAILSTABTEXT?.MATTERDETAILSTABTEXT) {
                  MATTERDETAILSTABTEXT.MATTERDETAILSTABTEXT = this.PreferenceForm.value[key];
                  localStorage.setItem('set_preferences', JSON.stringify(MATTERDETAILSTABTEXT));
                }
              }
              if (
                key == 'NAVBARFOLDED' ||
                key == 'NAVBARHIDE' ||
                key == 'OPENINNEWTAB' ||
                key == 'OPENINNEWTABWINDOWS' ||
                key == 'USEV11UI'
              ) {
                this.behaviorService.setToolBaarSetting({
                  NAVBARFOLDED: this.currentuser.NAVBARFOLDED,
                  NAVBARHIDE: this.currentuser.NAVBARHIDE,
                  OPENINNEWTABWINDOWS: this.currentuser.OPENINNEWTABWINDOWS,
                  OPENINNEWTAB: this.currentuser.OPENINNEWTAB,
                });
                localStorage.setItem(
                  'sidebar_fold_unfold',
                  JSON.stringify(this.currentuser.NAVBARFOLDED),
                );
                this.behaviorService.setMenuFoldUnfold(this.currentuser.NAVBARFOLDED);
                this.behaviorService.GetPreferences$.next(this.preferenceObjectData);
              }
              this.hyperlink.setColorSetting();
              this.hyperlink.setColorSettingWithHyperlink();
            }
            this.authenticationService.syncCurrentUser(this.currentuser);
            this.hyperlink.setColorSetting();
            this.hyperlink.setColorSettingWithHyperlink();
            this.behaviorService.UpdatedColorSystemSetting$.next(this.colorThemeval);
            const newTheme = this.PreferenceForm.controls['THEMECOLOUR'].value;
            if (previousTheme !== newTheme) {
              this.authenticationService.notifyOtherTabsOfThemeChange();
            }
            this.behaviorService.GetPreferences$.next(this.preferenceObjectData);
            this.behaviorService.setToolBaarSetting({
              NAVBARFOLDED: this.currentuser.NAVBARFOLDED,
              NAVBARHIDE: this.currentuser.NAVBARHIDE,
              OPENINNEWTABWINDOWS: this.currentuser.OPENINNEWTABWINDOWS,
              OPENINNEWTAB: this.currentuser.OPENINNEWTAB,
              USEV11UI: this.currentuser.USEV11UI,
            });
            this.isspiner = false;
            this.toastr.success('Preferences updated successfully');
            this.getPreferences();
          } else if (response.CODE == 451 && response.STATUS == 'warning') {
            this.isspiner = false;
            this.toastr.warning(response.MESSAGE);
          } else if (response.CODE == 450 && response.STATUS == 'error') {
            this.isspiner = false;
            this.toastr.error(response.MESSAGE);
          }
          this.cdr.markForCheck();
        },
        error: (error: any) => {
          this.isspiner = false;
          this.toastr.error(error);
          this.cdr.markForCheck();
        },
      });
  }
}
